module.exports = __webpack_public_path__ + "static/media/osaka-jo.2dd93946.jpg";